import { render, staticRenderFns } from "./ProductImageCarousel.vue?vue&type=template&id=3d755fe0&scoped=true"
import script from "./ProductImageCarousel.vue?vue&type=script&lang=js"
export * from "./ProductImageCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductImageCarousel.vue?vue&type=style&index=0&id=3d755fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d755fe0",
  null
  
)

export default component.exports